import dayjs from "dayjs";

export const FieldTypes = {
  SELECT: "SELECT",
  MULTISELECT: "MULTISELECT",
  TEXT: "TEXT",
  NUMBER: "NUMBER",
  URL: "URL",
  USER: "USER",
  DATE: "DATE",
};

const handleSelectField = (field, storedUserValue) => {
  const isMulti = field.type === FieldTypes.MULTISELECT;

  if (field.key.startsWith("azure")) {
    return storedUserValue;
  }

  if (isMulti) {
    const optionValues = [];
    storedUserValue.forEach((optionId) => {
      const foundOption = field.options.find(
        (option) => option.id === optionId
      );
      if (foundOption?.label) {
        optionValues.push(foundOption.label);
      }
    });
    return optionValues.join(", ");
  }
  const foundOption = field.options.find(
    (option) => option.id === storedUserValue
  );
  return foundOption?.label || "";
};

const handleTextField = (field, storedUserValue) => storedUserValue;

const handleNumberField = (field, storedUserValue) => {
  if (!storedUserValue) return "";

  if (field.format === "decimal") {
    return storedUserValue.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }
  if (field.format === "integer") {
    return storedUserValue.replace(/\D/g, "");
  }
  if (field.format === "percent") {
    return `${storedUserValue} %`;
  }
  return storedUserValue || "";
};

const handleDateField = (field, storedUserValue) => {
  if (storedUserValue) {
    return dayjs
      .unix(storedUserValue)
      .format(field?.recurring ? `MMM D` : `MMM D, YYYY`);
  }
  return "";
};

const handleUserField = (field, storedUserValue) => {
  return "";
};

const handleUndefinedField = () => "";

export const getUserValueFromField = (userValues, fields, fieldId) => {
  if (!fieldId || !fields?.length) return "";

  const storedValueById = userValues[`${fieldId}`];
  const storedField = fields?.find((field) => field.id === fieldId);

  if (!storedValueById) return "";

  const fieldHandler = {
    [FieldTypes.SELECT]: handleSelectField,
    [FieldTypes.MULTISELECT]: handleSelectField,
    [FieldTypes.TEXT]: handleTextField,
    [FieldTypes.NUMBER]: handleNumberField,
    [FieldTypes.URL]: handleTextField,
    [FieldTypes.DATE]: handleDateField,
    [FieldTypes.USER]: handleUserField,
    [undefined]: handleUndefinedField,
  };

  return fieldHandler[storedField?.type](storedField, storedValueById);
};
